(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saddlefish-subscription"] && !Shopify.designMode) return;
  try {
    
  let subscriptionArtwork;
  const loadSubscriptionArtwork = (image) => {
    if (!subscriptionArtwork) {
      subscriptionArtwork = Promise.all([
        image.dataset.artPartOne, image.dataset.artPartTwo, image.dataset.artPartThree, image.dataset.artPartFour
      ].map(url => fetch(url).then(response => {
        if (!response.ok) throw new Error('Subscription artwork unavailable');
        return response.text();
      }))).then(parts => 'data:image/png;base64,' + parts.join('').trim());
    }
    subscriptionArtwork.then(source => { image.src = source; }).catch(() => {});
  };
  if (!customElements.get('saddlefish-subscription')) {
    customElements.define('saddlefish-subscription', class extends HTMLElement {
      connectedCallback() {
        if (this.subscriptionInitialized) return;
        this.subscriptionInitialized = true;
        const artwork = this.querySelector('[data-subscription-art]');
        if (artwork) {
          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(entries => {
              if (entries.some(entry => entry.isIntersecting)) {
                loadSubscriptionArtwork(artwork);
                observer.disconnect();
              }
            }, { rootMargin: '300px' });
            observer.observe(artwork);
          } else {
            loadSubscriptionArtwork(artwork);
          }
        }
        const select = this.querySelector('[data-subscription-variant]');
        if (!select) return;
        const update = () => {
          this.querySelectorAll('[data-subscription-plans]').forEach(fieldset => {
            const active = fieldset.dataset.subscriptionPlans === select.value;
            fieldset.hidden = !active;
            fieldset.disabled = !active;
          });
        };
        select.addEventListener('change', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
